// removed by extract-text-webpack-plugin
module.exports = {"Base":"ArticleRollItem__Base-dCIdy","Figure":"ArticleRollItem__Figure-19n4u","Image":"ArticleRollItem__Image-GUXmE","Header":"ArticleRollItem__Header-3vUaX","Title":"ArticleRollItem__Title-JTii9","Title--small":"ArticleRollItem__Title--small-M2JEV","Content":"ArticleRollItem__Content-3-Pu8","Content--wide":"ArticleRollItem__Content--wide-KUl2L"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArticleRollItem/ArticleRollItem.css
 ** module id = 623
 ** module chunks = 0
 **/